import { useMemo } from 'react';
import { useAppSelector } from 'store/hook';

const useShowOnlyProductiveTrips = () => {
  const email = useAppSelector((state) => state.authReducer.email);

  const internalUserList = useAppSelector(
    (state) => state.internalUserReducer?.internalUserList
  );

  const externalUserList = useAppSelector(
    (state) => state.externalUserReducer?.externalUserList
  );

  const selectedUser = [...internalUserList, ...externalUserList].find(
    (user) => user.email === email
  );

  const userReducerLocation = useMemo(() => {
    const isInternalUser = [...internalUserList].find(
      (user) => user.email === email
    );

    if (isInternalUser) {
      return 'internalUserReducer';
    }

    return 'externalUserReducer';
  }, [internalUserList, externalUserList, email]);

  const showOnlyProductiveTrips =
    selectedUser?.showOnlyProductiveTrips ?? false;

  const userId = selectedUser?.userId ?? '';

  return {
    showOnlyProductiveTrips,
    userReducerLocation,
    userId,
  };
};

export default useShowOnlyProductiveTrips;
